// 认证 API
import { apiClient } from './client';
import type { AuthResponse, RefreshResponse } from './types';

export interface RegisterPayload {
  username: string;
  email: string;
  password: string;
  display_name?: string;
}

export interface LoginPayload {
  username_or_email: string;
  password: string;
  captcha_token: string;
  captcha_x: number;
}

export interface CaptchaChallenge {
  token: string;
  background_svg: string;
  piece_svg: string;
  piece_width: number;
  piece_height: number;
  y: number;
}

export interface UpdateMePayload {
  /** null = 清除,字符串 = 设置 */
  display_name: string | null;
}

export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
}

export const authApi = {
  async register(payload: RegisterPayload): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/register', payload);
    return data;
  },

  async login(payload: LoginPayload): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/login', payload);
    return data;
  },

  async refresh(refresh_token: string): Promise<RefreshResponse> {
    const { data } = await apiClient.post<RefreshResponse>('/v1/auth/refresh', { refresh_token });
    return data;
  },

  async captcha(): Promise<CaptchaChallenge> {
    const { data } = await apiClient.get<CaptchaChallenge>('/v1/auth/captcha');
    return data;
  },

  async me(): Promise<{ user: AuthResponse['user'] }> {
    const { data } = await apiClient.get<{ user: AuthResponse['user'] }>('/v1/auth/me');
    return data;
  },

  /** 改自己的 display_name(PATCH) */
  async updateMe(payload: UpdateMePayload): Promise<{ user: AuthResponse['user'] }> {
    const { data } = await apiClient.patch<{ user: AuthResponse['user'] }>(
      '/v1/users/me',
      payload,
    );
    return data;
  },

  /** 上传/更新头像(POST multipart/form-data,仅本地账号) */
  async uploadAvatar(file: File): Promise<{ user: AuthResponse['user'] }> {
    const formData = new FormData();
    formData.append('avatar', file);
    const { data } = await apiClient.post<{ user: AuthResponse['user'] }>(
      '/v1/users/me/avatar',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
    return data;
  },

  /** 改密码(POST,带 old_password) */
  async changePassword(payload: ChangePasswordPayload): Promise<void> {
    await apiClient.post('/v1/users/me/password', payload);
  },
};

